import { QueriesAndMutations } from '@paljs/types';
import pluralize from "pluralize"

export function createQueriesAndMutations(
  modelName: string,
  exclude: QueriesAndMutations[],
  onDelete?: boolean,
) {
  const operations = {
    queries: {
      type: 'type Query {',
      resolver: 'Query: {',
    },
    mutations: {
      type: 'type Mutation {',
      resolver: 'Mutation: {',
    },
  };

  const model = modelName.charAt(0).toLowerCase() + modelName.slice(1);
  const name = modelName.charAt(0).toUpperCase() + modelName.slice(1);
  const nameLower = modelName.charAt(0).toLowerCase() + modelName.slice(1);
  const namePlural = pluralize(name)
  const namePluralLower = namePlural.charAt(0).toLowerCase() + namePlural.slice(1);

  if (!exclude.includes('findUnique')) {
    operations.queries.type += `
    ${nameLower}(where: ${name}WhereUniqueInput!): ${modelName}`;
    operations.queries.resolver += `
    ${nameLower}: (_parent, args, {prisma}) => {
      return prisma.${model}.findUnique(args)
    },`;
  }

  if (!exclude.includes('findFirst')) {
    operations.queries.type += `
    first${name}(
      where: ${name}WhereInput
      orderBy: [${name}OrderByInput!]
      cursor: ${name}WhereUniqueInput
      distinct: ${name}ScalarFieldEnum
      skip: Int
      take: Int
    ): ${modelName}`;
    operations.queries.resolver += `
    first${name}: (_parent, args, {prisma}) => {
      return prisma.${model}.findFirst(args)
    },`;
  }

  if (!exclude.includes('findMany')) {
    operations.queries.type += `
    ${namePluralLower}(
      where: ${name}WhereInput
      orderBy: [${name}OrderByInput!]
      cursor: ${name}WhereUniqueInput
      distinct: ${name}ScalarFieldEnum
      skip: Int
      take: Int
    ): [${modelName}!]`;
    operations.queries.resolver += `
    ${namePluralLower}: (_parent, args, {prisma}) => {
      return prisma.${model}.findMany(args)
    },`;
  }

  if (!exclude.includes('findCount')) {
    operations.queries.type += `
    ${namePluralLower}Count(
      where: ${name}WhereInput
      orderBy: [${name}OrderByInput!]
      cursor: ${name}WhereUniqueInput
      distinct: ${name}ScalarFieldEnum
      skip: Int
      take: Int
    ): Int!`;
    operations.queries.resolver += `
    ${namePluralLower}Count: (_parent, args, {prisma}) => {
      return prisma.${model}.count(args)
    },`;
  }

  if (!exclude.includes('aggregate')) {
    operations.queries.type += `
    aggregate${namePlural}(
      where: ${name}WhereInput
      orderBy: [${name}OrderByInput!]
      cursor: ${name}WhereUniqueInput
      distinct: ${name}ScalarFieldEnum
      skip: Int
      take: Int
    ): Aggregate${name}`;
    operations.queries.resolver += `
    aggregate${namePlural}: (_parent, args, {prisma}) => {
      return prisma.${model}.aggregate(args)
    },`;
  }

  if (!exclude.includes('createOne')) {
    operations.mutations.type += `
    create${name}(data: ${name}CreateInput!): ${name}!`;
    operations.mutations.resolver += `
    create${name}: (_parent, args, {prisma}) => {
      return prisma.${model}.create(args)
    },`;
  }

  if (!exclude.includes('updateOne')) {
    operations.mutations.type += `
    update${name}(
      where: ${name}WhereUniqueInput!
      data: ${name}UpdateInput!
    ): ${modelName}!`;
    operations.mutations.resolver += `
    update${name}: (_parent, args, {prisma}) => {
      return prisma.${model}.update(args)
    },`;
  }

  if (!exclude.includes('deleteOne')) {
    operations.mutations.type += `
    delete${name}(where: ${name}WhereUniqueInput!): ${modelName}`;
    operations.mutations.resolver += `
    delete${name}: async (_parent, args, {prisma}) => {
      ${
        onDelete
          ? `await prisma.onDelete({ model: '${modelName}', where: args.where })`
          : ''
      }
      return prisma.${model}.delete(args)
    },`;
  }

  if (!exclude.includes('upsertOne')) {
    operations.mutations.type += `
    upsert${name}(
      where: ${name}WhereUniqueInput!
      create: ${name}CreateInput!
      update: ${name}UpdateInput!
    ): ${modelName}`;
    operations.mutations.resolver += `
    upsert${name}: async (_parent, args, {prisma}) => {
      return prisma.${model}.upsert(args)
    },`;
  }

  if (!exclude.includes('deleteMany')) {
    operations.mutations.type += `
    deleteMany${namePlural}(where: ${name}WhereInput): BatchPayload`;
    operations.mutations.resolver += `
    deleteMany${namePlural}: async (_parent, args, {prisma}) => {
      ${
        onDelete
          ? `await prisma.onDelete({ model: '${modelName}', where: args.where })`
          : ''
      }
      return prisma.${model}.deleteMany(args)
    },`;
  }

  if (!exclude.includes('updateMany')) {
    operations.mutations.type += `
    updateMany${namePlural}(
      where: ${name}WhereInput
      data: ${name}UpdateManyMutationInput
    ): BatchPayload`;
    operations.mutations.resolver += `
    updateMany${namePlural}: (_parent, args, {prisma}) => {
      return prisma.${model}.updateMany(args)
    },`;
  }

  operations.queries.type += `
}`;
  operations.queries.resolver += `
},`;
  operations.mutations.type += `
}`;
  operations.mutations.resolver += `
}`;
  return operations;
}
